import React, { useCallback, useMemo } from 'react';

import { Box } from '@lyearn/ui';
import {
  DatabaseFormEditorActionEnum,
  UpdateDatabaseFieldParams,
} from '@/modules/corporate/modules/database/views/FormView/components/DatabaseFormEditor/types';
import FieldSettings from '@/modules/corporate/modules/database/views/FormView/components/FormFieldSettings/components/FieldSettings';
import { useSurveyEditorContext } from '@/modules/corporate/modules/survey/views/SurveyEditor/context/SurveyEditorContext';

import WelcomeBlockSettings from '../WelcomeBlockSettings';

function SurveyFieldSettings() {
  const { fields, isFieldPublished, uiState, onAction, formKey } = useSurveyEditorContext();

  const selectedField = useMemo(
    () => fields.find((field) => field.metadataField.fieldId === uiState.selectedBlockId),
    [fields, uiState.selectedBlockId],
  );

  const onChange = useCallback(
    (payload: UpdateDatabaseFieldParams) => {
      onAction({ type: DatabaseFormEditorActionEnum.UpdateField, payload });
    },
    [onAction],
  );

  if (!selectedField) {
    return <WelcomeBlockSettings />;
  }

  return (
    <Box className="p-16">
      <FieldSettings
        key={`${selectedField.viewField.fieldId}_${selectedField.metadataField.type}_${formKey}`}
        allowPartialUpdates={isFieldPublished(selectedField.viewField.fieldId)}
        field={selectedField}
        onChange={onChange}
      />
    </Box>
  );
}

export default SurveyFieldSettings;
